import { render, staticRenderFns } from "./RequestBoxHelpTab.vue?vue&type=template&id=468a0025&"
import script from "./RequestBoxHelpTab.vue?vue&type=script&lang=js&"
export * from "./RequestBoxHelpTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports